import PropTypes from 'prop-types';
import StyledAutoComplete from 'components/commons/StyledAutoComplete';
import TextField from 'components/commons/TextField';
import SearchFilterUtil from 'lib/SearchFilterUtil';

const CreatableSelect = ({
    options,
    value,
    onChange,
    onInputChange,
    label,
    error,
    filterOptions,
    getOptionDisabled,
    isOptionEqualToValue,
    formatter,
    selected,
    width,
    tooltip,
    active,
    maxInputLength = 15,
    inputStyle,
    ...rest
}) => {
    const getNewParams = (params) => ({
        ...params,
        onInput: (e) => {
            if (onInputChange) {
                onInputChange(e);
            }
            SearchFilterUtil.handleAutocompleteInputChange(e, { params, maxInputLength });
        },
    });
    return (
        <StyledAutoComplete
            disablePortal
            options={options}
            value={value}
            isOptionEqualToValue={isOptionEqualToValue}
            onChange={onChange}
            freeSolo
            disableClearable
            renderInput={(params) => (
                <TextField
                    params={getNewParams(params)}
                    label={label}
                    isHighlighted={active !== undefined
                        ? active
                        : selected && selected.value !== ''}
                    error={!!error}
                    tooltip={tooltip}
                    inputStyle={inputStyle}
                />
            )}
            filterOptions={filterOptions}
            getOptionDisabled={getOptionDisabled}
            clearOnBlur
            selectOnFocus
            autoHighlight
            forcePopupIcon
            {...rest}
        />
    );
};

CreatableSelect.propTypes = {
    options: PropTypes.array.isRequired,
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onInputChange: PropTypes.func,
    label: PropTypes.string,
    error: PropTypes.bool,
    active: PropTypes.bool,
    filterOptions: PropTypes.func,
    getOptionDisabled: PropTypes.func,
    isOptionEqualToValue: PropTypes.func,
    formatter: PropTypes.func,
    selected: PropTypes.object,
    tooltip: PropTypes.string,
    inputStyle: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CreatableSelect;